// extracted by mini-css-extract-plugin
module.exports = {"whyUseContainer":"WhyToUseSection_whyUseContainer__1GdJY","portalBenefits":"WhyToUseSection_portalBenefits__2Y61b","points":"WhyToUseSection_points__kTL6u"};